import styled, { css } from "styled-components";

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: var(--fd-space-space-1);
  padding-left: var(--fd-space-space-3);
`;

export const HeaderContainer = styled.div<{ isMobile: boolean }>`
  padding: var(--fd-space-space-4);
  background: var(--fd-colors-background-surface);
  border-radius: ${({ isMobile }) =>
    isMobile
      ? "0"
      : "var(--fd-radii-border-radius-020) var(--fd-radii-border-radius-020) 0 0"};
`;

export const Section = styled.div<{
  isMobile: boolean;
}>`
  background: var(--fd-colors-background-base);
  padding-top: var(--fd-space-space-4);
  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: var(--fd-space-space-4) 0;
    `};
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-right: var(--fd-space-space-1);
  background: var(--fd-colors-background-surface);
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
`;

export const HeaderModalContainer = styled.div`
  display: flex;
  padding: var(--fd-space-space-3);
  background: var(--fd-colors-background-surface);
  border-radius: var(--fd-radii-border-radius-020)
    var(--fd-radii-border-radius-020) 0 0;
  align-items: center;
  width: 100%;
  justify-content: center;
  border-bottom: var(--fd-border-widths-border-width-010)
    var(--fd-border-styles-border-style-solid-style)
    var(--fd-colors-border-subtle);
`;
